var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiplierDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 17C29 23.6274 23.6274 29 17 29C10.3726 29 5 23.6274 5 17C5 10.3726 10.3726 5 17 5C23.6274 5 29 10.3726 29 17ZM6.90007 17C6.90007 22.578 11.422 27.0999 17 27.0999C22.578 27.0999 27.0999 22.578 27.0999 17C27.0999 11.422 22.578 6.90007 17 6.90007C11.422 6.90007 6.90007 11.422 6.90007 17Z",
    fill: "#7C6EFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 25.4809C22.3915 24.8759 25.5716 21.3093 25.5716 17C25.5716 12.6906 22.3915 9.12407 18.25 8.51902V25.4809ZM16.75 8.43213C14.8686 8.48605 13.1391 9.14621 11.75 10.2241V23.7758C13.1391 24.8537 14.8686 25.5139 16.75 25.5678V8.43213ZM10.25 22.2831V11.7169C9.10898 13.1727 8.42871 15.0069 8.42871 17C8.42871 18.9931 9.10898 20.8273 10.25 22.2831Z",
    fill: "#7C6EFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplierDone);
export default __webpack_public_path__ + "static/media/multiplier-done.051b6b8ffb366d6b3b036eec54a8daf6.svg";
export { ForwardRef as ReactComponent };